export const SENTRY_DSN =
  "https://157187132db14cdf86d93385c46d43a1@o525661.ingest.sentry.io/5640148";

export const SENTRY_IPC_NAMESPACE = "routine-sentry";

export const SENTRY_ORG_SLUG = "routine-co";

export function releaseName(version: string): string {
  return `routine@${version}`;
}

/**
 * Issues search URL for a captured event ID. Prefer a wide window so the
 * link stays useful after the default 14d/30d Issues filter would hide it.
 */
export function userReportEventUrl(eventId: string): string {
  return `https://${SENTRY_ORG_SLUG}.sentry.io/organizations/${SENTRY_ORG_SLUG}/issues/?query=${encodeURIComponent(eventId)}&statsPeriod=90d`;
}
